import { useCallback, useRef } from 'react';
const LONG_PRESS_MS = 500;
export function useLongPress(callback) {
    const timer = useRef(null);
    const start = useCallback(() => {
        timer.current = setTimeout(callback, LONG_PRESS_MS);
    }, [callback]);
    const cancel = useCallback(() => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
    }, []);
    return { onTouchStart: start, onTouchEnd: cancel, onTouchMove: cancel };
}
